// extracted by mini-css-extract-plugin
module.exports = {"VerticalNavigationitemSub":"VerticalNavigationitemSub_VerticalNavigationitemSub__ZKUvE"};